import { TransactionsRefundRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useTransactionRefund({ bearer }: { bearer: string }) {
  const [fetching, setFetching] = useState(false);

  async function transactionRefund(params: TransactionsRefundRequest) {
    try {
      setFetching(true);
      const res = await api.postTransactionRefund(params, bearer);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, transactionRefund };
}
